import React from 'react';
import TablaDTE from 'App/components/TablaDTE';

function Recibidos() {

    return (
        <div>
            <TablaDTE tipoDTE="recibidos" titulo="Recibidos" />
        </div>
    )
}

export default Recibidos;